// ALERT/ADVISORY POST component
//*******************************************************************
//*******************************************************************
//IMPORTS:
//EXTERNAL & PACKAGE
import React from 'react'
import { Link, graphql } from 'gatsby'
import Helmet from "react-helmet"

//component dependencies
import Heading from '../components/heading'
import Navbar from '../components/navbar'
import Footer from '../components/footer'
import Header from '../components/Header'

import SEO from '../components/seo.js'
//*******************************************************************
//*******************************************************************
class NewTemplate extends React.Component { 
    
    render() {
        
        const post = this.props.data.allButterPost.edges[0].node
		const page = this.props.data.allButterPage.edges[0].node
        const { previous, next } = this.props.pageContext

        return (

            <div>

                <Helmet>
                    <script defer src="https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5e263a6ccdf8622d" type="text/javascript" />
		    		<script defer src="/chatbot.js"type="text/javascript"></script>
                </Helmet>
            
                <SEO title={post.seo_title} description={post.meta_description} />
            
                <Heading/>
            
                <Navbar/>
                
                <div class="container">            
               	<div class="row">
			    	<div class="col-md-8 mb-4 px-4 ">
                        
						<h1 class="pageHeader postHeader">{post.seo_title}</h1>
                       
            
                        {post.tags.map(tag => (

                            <Header styles="header leftHeader postType" title={tag.name}/>

                        ))}
  
                            <p class="standardText">Original Release Date: {post.date}</p>
                            
                            <div class="breachPostSummary standardText" dangerouslySetInnerHTML={{ __html: post.body }}/>

                            <ul class="postLinks">
                                
                                <li class="inlineLi standardText">
                                {next && (
                                  <Link to={`/this-is-security/${next.slug}`} rel="next">
                                   ← {next.seo_title} 
                                  </Link>
                                )}
                                </li>
                                
                                <li class="inlineLi standardText">
                                {previous && (
                                  <Link to={`/this-is-security/${previous.slug}`} rel="prev">
                                     {previous.seo_title} →
                                  </Link>
                                )}
                                </li>
                                
                            </ul>       
                        </div>
                    	<div class="col-md-4 mb-4">
					<section>
					<form class="text-center border border-light p-3">
					  <p class="h4 text-center">Join & Subscribe</p>
					  <p>Never miss an update. Sign up for a no cost membership today! Receive up-to-date content in our <a href="/weekly-bulletin/" target="_blank">weekly bulletin</a>.</p>
						<p class="text-center">
						<a href="/members/" target="_blank" class="btn btn-outline-info" role="button" >Sign Up</a>
					  </p>
					</form>	
      				</section>

                	<section class="text-center mb-5">

					<h4 class="mb-4">Featured Content</h4>
						<ul class="list-group list-group-flush">
						{page.carousel_content.map(carousel => (
							<li class="list-group-item text-truncate"><a href={carousel.url}>{carousel.caption}</a>></li>
                        ))}
					</ul>

				  </section>
					
                </div>
                </div>                  
                </div>

                <Footer/>
                
            </div>

        )
    }
}

export default NewTemplate

export const pageQuery = graphql`
  query NewPostBySlug($slug: String!) {
    allButterPost(filter: { slug: { eq: $slug } }) {
      edges {
        node {
          id
          body
          seo_title
          meta_description
          date
          categories {
            name
          }
            tags {
            name
}
        }
      }
    }
	allButterPage(filter: {slug: {eq: "index"}}) {
    edges {
      node {
        carousel_content {
          caption
          url
        }
      }
    }
  }
  }
`